// extracted by mini-css-extract-plugin
export default {"launcher":"styles_launcher__UMY3o","hidden":"styles_hidden__BbZmp"};